<template>
	<div>
		<p>Please enter your support query below or email us at <a href="mailto:support@yardonline.com">support@yardonline.com</a>.</p>
		<div class="row">
			<div class="col-12">
				<InputText id="subject" name="Issue" :form="supportForm" :errors="supportErrors"/>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<InputTextArea id="message" name="Description" :form="supportForm" :errors="supportErrors"/>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<button class="button-action" @click="save">Submit</button>
			</div>
		</div>
	</div>
</template>

<script>
import InputText from '../Form/InputText.vue'
import InputTextArea from '../Form/InputTextArea.vue'
import API from '../../lib/api'

export default {
	components: {
		InputText,
		InputTextArea
	},

	data() {
		return {
			supportForm: {},
			supportErrors: {},
			userRequiredFields: ['subject', 'message']
		}
	},
	methods: {
		formIsValid() {
			let validForm = true
			
			this.supportErrors = {}

			this.userRequiredFields.forEach(field => {
				if(!this.supportForm.hasOwnProperty(field) || this.supportForm[field] == '') {
					this.supportErrors[field] = 'This field is required.'
					validForm = false
				}
			})

			return validForm
		},
		save() {
			if(!this.formIsValid()) {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'Form error - please check and re-submit',
					timeout: 3000
				})
				return
			}
			this.$store.commit('app/setLoading', true)
			const api = new API(1, 'support')

			api.post(this.supportForm)
			.then(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: 'Your support request has been sent. We will be in touch soon.',
				})
				this.supportForm = {}
			})
			.catch(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	}
}
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Support/Form.vue